<div class="documentos_requeridos">

  @if (!!filesToUpload.length) {
  <div class="files">
    <p class="text-danger m-0 p-0">
      Los siguientes archivos son requeridos para proceder con el reclamo.
    </p>
    <form (ngSubmit)="onUploadFile()">

      <div class="uploads-container">
        <div *ngFor="let fileType of filesToUpload" class="input-box file-to-upload mt-4">
          <label for="file">{{fileType.description}}</label>
          <input (change)="onFileSelected($event, fileType.code, fileType.type)" id="file-{{fileType.code}}" name="file"
            type="file" class="input-field file" placeholder="" />
          @if (!!fileType.message) {
          <small class="message">({{ fileType.message }})</small>
          }
        </div>
      </div>

      <button class="btn-m-new enviar mt-4" type="submit">Enviar</button>
    </form>
  </div>

  <hr>
  <h5 class="title">Información de reclamo</h5>
  }
  <app-modal-envio-correcto
    [isOpen]="showModal"
    message="Archivos enviados correctamente"
    (continue)="onContinue()"
  ></app-modal-envio-correcto>
</div>
